'use strict';

/* jshint -W098 */
angular.module('mean.accounts-receivable').controller('tradesAccountsReceivableController', ['$scope', '$window', '$rootScope', '$location', 'Users', 'Global', 'MeanUser', 'toaster', '$filter', 'userService', 'contactService', 'Trades', 'aceUtils', 'tradeCodeService', 'Builders', 'Projects', 'TradeDrawService', 'Estimates', 'TradeInvoices', 'Extras',
  function($scope, $window, $rootScope, $location, Users, Global, MeanUser, toaster, $filter, userService, contactService, Trades, aceUtils, tradeCodeService, Builders, Projects, TradeDrawService, Estimates, TradeInvoices, Extras) {
    var vm = this;
    vm.scope = $scope;
    vm.user = MeanUser.user;

    //vm.acceptable_users = ['130010000', '130050000'];
    vm.company_emails = [];

    // if(vm.acceptable_users.indexOf(vm.user.username) === -1) {
    //     toaster.pop('error', 'New Functionality Error', 
    //         'This functionality is not available to all users at this time.');
    //     $window.location.href = "/";
    //     return;
    // }
    vm.trade_code = tradeCodeService.getCode(vm.user.trade[0]);
    //TradeDrawService.loadSettings(vm.trade_code, vm.user.contractor_code);
    TradeDrawService.loadSettings(
        vm.trade_code, vm.user.contractor_code, vm.user.trade[0]);

    console.log('in tradesAccountsReceivableController');

    $scope.getCompanyEmails = function() {
        return vm.company_emails;
    }
    //get a signal from billingInvoice and send it to billingProjects
    $scope.invoiceDataRowSelected = function(data) {
        vm.scope.$broadcast('InvoiceDataRowSelected', data);
    };

    $scope.removeEstimate = function(project, estimate) {
        var project_est = $filter('filter')(vm.company_estimates, {
                    'job_code': project.job_code})[0];
        var removed = _.remove(project_est.estimates, function(est) {
            return estimate.type == est.type && 
                estimate.phase == est.phase;
        });

        project_est.$update(function(success) {
            project = success;
            if(removed.length == 1) {
                toaster.pop('success', 'Estimate Updated');
                var dummy = {
                    amount: 0,
                    billed: 0,
                    date: null,
                    details: [],
                    number: removed[0].number,
                    paid: 0,
                    phase: removed[0].phase,
                    type: removed[0].type
                }
                // project.estimates.push(dummy);
                // project.estimate_data = project.estimates;
                project.estimate_data.push(dummy);

                vm.scope.$broadcast('EstimateDataRemoved', estimate);
                var update = $filter('filter')(vm.company_estimates, {
                    'job_code': project.job_code})[0];
                for(var i=0; i<update.estimates.length; i++) {
                    if(update.estimates[i].type == estimate.type && 
                        update.estimates[i].phase == estimate.phase) {
                        update.estimates[i].amount = 0;
                        update.estimates[i].billed = 0;
                        update.estimates[i].paid = 0;
                        update.estimates[i].date = null;
                        update.estimates[i].details = [];
                    }
                }

                var comp_idx = -1;
                var proj_idx = -1;
                for(var i=0; i<vm.data.length; i++) {
                    if(project.trade_code === vm.data[i].trade_code &&
                        project.company_code === vm.data[i].company_code) {
                        comp_idx = i;
                        proj_idx = vm.findProjctIndex(vm.data[i], project.job_code);

                        if(proj_idx != -1)
                            break;
                    }
                }

                var builder = vm.data[comp_idx];
                var project = builder.children[proj_idx];
                vm.updateProjectEsitmateTotal(project);
                vm.updateBuilderEstimateTotal(builder);
            } else if(removed.length > 1) {
                toaster.pop('error', 'Estimate Remove Error', 
                    'Removed too many. Refresh and check data.');
            }
        }, function(error) {
            toaster.pop('Error', 'Estimate Update Error', error);
        });
    }

    $scope.removeInvoice = function(project, invoice) {
        vm.scope.$broadcast('InvoiceDataRemoved', invoice);
        var update = $filter('filter')(vm.company_invoices, {
            'job_code': project.job_code})[0];

        if(update) {
            _.remove(update.invoices, function(inv) {
                return inv.type == invoice.type && 
                    inv.phase == invoice.phase &&
                    inv.number == invoice.number;
            });
        }

        return update;
    }

    $scope.getProjectEstimates = function(job_code) {
        return $filter('filter')(vm.company_estimates, {'job_code': job_code})[0];
    };

    $scope.getProjectInvoices = function(job_code) {
        return $filter('filter')(vm.company_invoices, {'job_code': job_code})[0];
    };

    $scope.getAllInvoices = function() {
        return vm.company_invoices;
    };

    $scope.updateProjectEstimate = function(estimate) {
        var idx = vm.company_estimates.indexOf(estimate);
        if(idx !== -1) {
            vm.company_estimates[idx] = estimate;

            var comp_idx = -1;
            var proj_idx = -1;
            for(var i=0; i<vm.data.length; i++) {
                if(estimate.trade_code === vm.data[i].trade_code &&
                    estimate.company_code === vm.data[i].company_code) {
                    comp_idx = i;
                    proj_idx = vm.findProjctIndex(vm.data[i], estimate.job_code);

                    if(proj_idx != -1)
                        break;
                }
            }

            var builder = vm.data[comp_idx];
            var project = builder.children[proj_idx];

            _.each(estimate.estimates, function(est) {
                var est_item = $filter('filter')(project.estimate_data, {'_id': est._id}, true);

                if(est_item.length != 1) {
                    console.log('there is an issue with finding this estimate');
                } else {
                    est_item[0].amount = est.amount;
                    est_item[0].billed = est.billed;
                    est_item[0].paid = est.paid;
                    est_item[0].date = new Date(est.date);

                    _.each(est.details, function(detail) {
                        var inlist = $filter('filter')(est_item[0].details, {'_id': detail._id}, true);

                        if(inlist.length != 1) {
                            console.log('there is an issue with finding this estimate detail');
                        } else {
                            inlist[0].amount = detail.amount;
                            inlist[0].billed = detail.billed;
                            inlist[0].paid = detail.paid;
                        }
                    });
                }
            });

            vm.updateProjectEsitmateTotal(project);
            vm.updateBuilderEstimateTotal(builder);
        } else {
            //vm.company_estimates.push(estimate);
            toaster.pop('error', 'Estimate Not Loaded', 'Refresh the page.');
        }
    };

    $scope.getProjectExtras = function(proj_id, phase) {
        return $filter('filter')(vm.trade_extras, { 'project_id': proj_id }, true);
    };

    vm.findProjctIndex = function(builder, job_code) {
        var proj_idx = -1;
        for(var i=0; i<builder.children.length; i++) {
            if(builder.children[i].job_code === job_code) {
                proj_idx = i;
                break;
            }
        }
        return proj_idx;
    };

    $rootScope.$on("InvoiceUpdated", function(e, args) {
        console.log('In the InvoiceUpdated receive function');
        var inlist = $filter('filter')(vm.company_invoices, {
            'trade_code': vm.trade_code, 
            'company_code': vm.user.contractor_code}, true);

        if(inlist.length == 0) {
            vm.company_invoices.push(args);
        } else {
            inlist = args
        }

        var comp_idx = -1;
        var proj_idx = -1;
        for(var i=0; i<vm.data.length; i++) {
            if(args.trade_code === vm.data[i].trade_code &&
                args.company_code === vm.data[i].company_code) {
                comp_idx = i;
                proj_idx = vm.findProjctIndex(vm.data[i], args.job_code);

                if(proj_idx != -1)
                    break;
            }
        }

        var builder = vm.data[comp_idx];
        var project = builder.children[proj_idx];

        vm.updateProjectInvoiceTotal(project);
        vm.updateBuilderInvoiceTotal(builder);

        // _.each(args.invoices, function(invoice) {
        //     if(args.invoice_type == invoice.type &&
        //         args.project_phase == invoice.phase)
        // });
    });

    vm.updateProjectInvoiceTotal = function(project) {
        var project_total = 0;
        var project_paid = 0;
        _.each(project.children, function(phase) {
            phase.invoiced = 0;
            phase.paid = 0;
            _.each(phase.invoice_data, function(invoice) {
                phase.invoiced += invoice.amount;
                _.each(invoice.payments, function(payment) {
                    phase.paid += payment.amount;
                });
            });
            _.each(phase.estimate_data, function(est) {
                console.log(est);
            })
            project_total += phase.invoiced;
            project_paid += phase.paid;
        });
        project.invoiced = project_total;
        project.paid = project_paid;
    };

    vm.updateBuilderInvoiceTotal = function(builder) {
        builder.invoiced = 0;
        builder.paid = 0;
        _.each(builder.children, function(project) {
            builder.invoiced += project.invoiced;
            builder.paid += project.paid;
        });
    };

    $rootScope.$on("EstimateUpdated", function(e, args) {
        console.log('In the EstimateUpdated receive function');
        var inlist = $filter('filter')(vm.company_estimates, {'job_code': args.job_code})[0];
        if(!inlist) {
            vm.company_estimates.push(args);
        }

        var comp_idx = -1;
        var proj_idx = -1;
        for(var i=0; i<vm.data.length; i++) {
            if(args.trade_code === vm.data[i].trade_code &&
                args.company_code === vm.data[i].company_code) {
                comp_idx = i;
                proj_idx = vm.findProjctIndex(vm.data[i], args.job_code);

                if(proj_idx != -1)
                    break;
            }
        }

        var builder = vm.data[comp_idx];
        var project = builder.children[proj_idx];
        vm.updateProjectEsitmateTotal(project);
        vm.updateBuilderEstimateTotal(builder);
    });

    vm.updateProjectEsitmateTotal = function(project) {
        var project_total = 0;
        _.each(project.children, function(phase) {
            phase.estimate_total = 0;
            if(!phase.estimate_data) {
                phase.estimate_data = phase.estimates;
            }
            _.each(phase.estimate_data, function(estimate) {
                if(!estimate.amount) {
                    estimate.amount = 0;
                    _.each(estimate.details,function(item) {
                        estimate.amount += item.amount;
                    });
                }
                phase.estimate_total += estimate.amount;
            });
            project_total += phase.estimate_total;
        });
        project.estimate_total = project_total;
    };

    vm.updateBuilderEstimateTotal = function(builder) {
        builder.estimate_total = 0;
        _.each(builder.estimate_data, function(estimate) {
            builder.estimate_total += estimate.amount;
        });
    };

    vm.state = $location.state();
    var show_error = true;
    if(vm.state) {
        if(vm.state.from_billing_setup) {
            show_error = false;
        }
    };
    
    $scope.getProjectData = function(complete) {
        vm.data = [];
        vm.showSpinner = true;

        userService.getMainAccount(vm.user.username).then(function(main_account) {
            vm.main_account = main_account;
            Trades.query({'main_account_id': vm.main_account._id}, function(trade) {
                vm.my_trade = trade[0];

                Projects.query({'all_my_projects': true, 
                    'complete': complete,
                    'username': userService.getMainUsername(vm.user.username)}, function(projects) {

                    Extras.query({'trade_id': vm.my_trade._id, 
                        'trade': vm.user.trade[0],
                        'type': 'TradeDontPopulate' }, function(extrasdb) {
                        vm.trade_extras = extrasdb;

                        TradeInvoices.query({'trade_code': vm.trade_code, 
                            'company_code': vm.user.contractor_code}, function(invoices) {
                            vm.company_invoices = invoices;

                            Estimates.query({'trade_code': vm.trade_code, 
                                'company_code': vm.user.contractor_code}, function(estimates) {
                                vm.data = [];
                                vm.project_errors = [];
                                vm.company_estimates = estimates;

                                var uinque_trade_builders = _.uniq(_.map(_.flatten(_.map(projects, "builder")), "name"))

                                _.each(uinque_trade_builders, function(builder, builder_idx) {
                                    var bProjects = _.remove(projects, function(project) {
                                        return project.builder.name === builder;
                                    });

                                    var project_estimate = $filter('filter')(estimates, {
                                        'job_code': bProjects[0].job_code }, true)[0];

                                    var builder_list = [];

                                    var data_length = vm.data.length-1;
                                    var builder_total = 0;
                                    _.each(bProjects, function(proj, project_idx) {
                                        if(project_idx === 0) {
                                            vm.data.push({
                                                "project_id" : proj._id,
                                                "name" : proj.builder.name,
                                                "type": "builder",
                                                "trade_code": proj.trade_code,
                                                "company_code": proj.company_code,
                                                "address_one": proj.builder.address_one,
                                                "address_two": proj.builder.city + ', ' + 
                                                    proj.builder.state + '. ' + proj.builder.zip,
                                                "total" : 0, 
                                                "estimate_total" : (project_estimate)?project_estimate.amount:0,
                                                "invoiced": 0,
                                                "paid": 0,
                                                children: []
                                            });

                                            builder_list.push({
                                                name: proj.builder.name
                                            });
                                        }

                                        var lots = $filter('unique')(proj.lots, 'phase');
                                        var phases = [];
                                        _.each(lots, function(lot) {
                                            phases.push(lot.phase);
                                        });

                                        var project_estimate = $filter('filter')(estimates, {
                                            'job_code': proj.job_code }, true)[0];

                                        var project_invoice = $filter('filter')(vm.company_invoices, {
                                            'job_code': proj.job_code }, true)[0];
                                        var invoice_amount = 0;
                                        var paid = 0;
                                        if(project_invoice) {
                                            _.each(project_invoice.invoices, function(inv) {
                                                invoice_amount += inv.amount;
                                                paid += inv.paid;
                                            });
                                        }

                                        var trade_options = TradeDrawService.getProjectOptions(
                                            proj.trade_code, proj.company_code, proj.job_code);
                                        
                                        vm.data[builder_idx].children.push({
                                            "project_id" : proj._id,
                                            "name" : proj.name,
                                            "type": "project",
                                            "address_one": proj.contact.address_one,
                                            "address_two": proj.contact.address_two,
                                            "job_code": proj.job_code,
                                            "total" : 0, 
                                            "estimate_total" : (project_estimate)?project_estimate.amount:0,
                                            "invoiced": invoice_amount,
                                            "paid": paid,
                                            children: [],
                                            "plans": proj.plan_codes,
                                            "phases": phases
                                        });

                                        var current_idx = vm.data[builder_idx].children.length-1;
                                        var phase_total = 0;
                                        var phase_estimate = 0;

                                        var child_length = vm.data[builder_idx].children.length-1
                                        _.each(phases, function(phase) {
                                            //contract totals should be contained with the proj.plan_codes data
                                            //but we need to determine lot reivision as well
                                            var job_total = 0;
                                            var estimate_total = 0;
                                            var option_total = 0;
                                            var extra_total = 0;
                                            var billed = 0;
                                            var paid = 0;
                                            var open = 0;
                                            var contract_database = false;
                                            var option_database = false;
                                            var extra_database = false;
                                            var est = null;
                                            var invoices = null;

                                            var project_estimate = $filter('filter')(estimates, {
                                                'job_code': proj.job_code }, true)[0];

                                            //var valid_estimate = false;
                                            if(project_estimate) {
                                                est = $filter('filter')(project_estimate.estimates, {
                                                    'phase': phase}, true);
                                                if(est && est.length > 0) {
                                                    _.each(est, function(e) {
                                                        if(e.type === 'contract') {
                                                            contract_database = true;
                                                        } else if(e.type === 'option') {
                                                            option_database = true;
                                                        } else {
                                                            extra_database = true;
                                                        }
                                                        estimate_total += e.amount;
                                                    });
                                                } 
                                            } 

                                            if(trade_options) {
                                                console.log('need to grab project option data here to get a total...I think');
                                            }

                                            var project_invoice = $filter('filter')(vm.company_invoices, {
                                                'job_code': proj.job_code }, true)[0];

                                            if(project_invoice) {
                                                var invoices = $filter('filter')(project_invoice.invoices, {
                                                    'phase': phase}, true);
                                                if(invoices) {
                                                    _.each(invoices, function(i) {
                                                        billed += i.amount;
                                                        paid += i.paid;
                                                        var payments = 0;
                                                        _.each(i.payments, function(pay) {
                                                            payments += pay.amount;
                                                        });
                                                        i.open = i.amount - payments;
                                                    });
                                                }
                                            }

                                            if(phase === '00' && proj.job_code === '0058') {
                                                console.log('00-0058 billed value: ' + billed);
                                            }
                                            if(phase === '05' && proj.job_code === '0058') {
                                                console.log('05-0058 billed value: ' + billed);
                                            }

                                            job_total = $scope.getJobCostTotal(proj, phase);

                                            if(est && est.length > 0) {
                                                vm.data[builder_idx].children[child_length].children.push({
                                                    "name" : proj.name + ' - ' + phase,
                                                    "project_id" : proj._id,
                                                    "type": "phase",
                                                    "phase": phase,
                                                    "plans": proj.plan_codes,
                                                    "total" : job_total, 
                                                    "estimate_total" : estimate_total, 
                                                    "invoiced": billed,
                                                    "paid": paid,
                                                    "open": open,
                                                    "estimates": est,
                                                    "invoice_data": invoices
                                                });
                                            } else {
                                                vm.data[builder_idx].children[child_length].children.push({
                                                    "name" : proj.name + ' - ' + phase,
                                                    "project_id" : proj._id,
                                                    "type": "phase",
                                                    "phase": phase,
                                                    "plans": proj.plan_codes,
                                                    "total" : job_total, 
                                                    "estimate_total" : estimate_total, 
                                                    "invoiced": billed,
                                                    "paid": paid,
                                                    "open": open,
                                                    "estimates": []
                                                });
                                            }

                                            var phase_length = vm.data[builder_idx].children[child_length].children.length-1;
                                            if(!contract_database) {
                                                vm.data[builder_idx].children[child_length].children[phase_length].estimates.push({
                                                    'type': 'contract',
                                                    'number': proj.job_code + '-' + phase + '-C',
                                                    "date": null,
                                                    "phase": phase,
                                                    "amount": option_total,
                                                    "billed": 0,
                                                    "paid": 0,
                                                    "open": 0
                                                });
                                            }

                                            if(!option_database) {
                                                vm.data[builder_idx].children[child_length].children[phase_length].estimates.push({
                                                    'type': 'option',
                                                    'number': proj.job_code + '-' + phase + '-OP',
                                                    "date": null,
                                                    "phase": phase,
                                                    "amount": option_total,
                                                    "billed": 0,
                                                    "paid": 0,
                                                    "open": 0
                                                });
                                            }

                                            if(!extra_database) {
                                                vm.data[builder_idx].children[child_length].children[phase_length].estimates.push({
                                                    'type': 'extra',
                                                    'number': proj.job_code + '-' + phase + '-E',
                                                    "date": null,
                                                    "phase": phase,
                                                    "amount": extra_total,
                                                    "billed": 0,
                                                    "paid": 0,
                                                    "open": 0
                                                });
                                            }

                                            phase_total += job_total + option_total + extra_total;
                                            phase_estimate += estimate_total;
                                        });

                                        vm.data[builder_idx].children[current_idx].estimate_total = phase_estimate;
                                        vm.data[builder_idx].children[current_idx].total = phase_total;
                                        vm.data[builder_idx].total += 
                                            vm.data[builder_idx].children[current_idx].total;
                                        vm.data[builder_idx].estimate_total += 
                                            vm.data[builder_idx].children[current_idx].estimate_total;
                                        vm.data[builder_idx].invoiced += 
                                            vm.data[builder_idx].children[current_idx].invoiced;
                                        vm.data[builder_idx].paid += 
                                            vm.data[builder_idx].children[current_idx].paid;
                                    });
                                });

                                if(show_error && vm.project_errors.length !== 0) {
                                    var project_string = '';
                                    _.each(vm.project_errors, function(proj, idx) {
                                        project_string += proj;

                                        if(idx < vm.project_errors.length-1) {
                                            project_string += ', '
                                        }
                                    });

                                    toaster.pop({
                                        'type': 'error', 
                                        'body': 'proj-error-msg',
                                        'bodyOutputType': 'directive',
                                        'directiveData': { projects: project_string },
                                        'timeout': 0,
                                        'showCloseButton': true
                                    });
                                }

                                vm.scope.$broadcast('AcctRecDataReady', vm.data);
                                vm.showSpinner = false;
                            });
                        });
                    });
                });
            });
        });
    };

    $scope.getProjectData(false);

    $scope.getJobCostTotal = function(proj, phase) {
        //all the lots that are part of this phase
        var phase_lots = $filter('filter')(proj.lots, {'phase': phase}, true);
        var total = 0;
        var project_extras = $filter('filter')(vm.trade_extras, {
            'project_id': proj._id, 'phase': phase}, true);

        var revision = 1;
        _.each(phase_lots, function(lot) {
            if(lot.plan !== 'T&M') {
                //check if this lot has revisions applied by a trade.
                if(lot.revisions) {
                    var my_rev = $filter('filter')(lot.revisions, {
                        'trade': vm.user.trade[0]}, true)[0];
                    //don't assume that my trade has a revision
                    if(my_rev) {
                        revision = my_rev.revision;
                    }
                }

                //now that we've identified the lot's trade revision,
                //lets now get the appropriate totals for the plan
                var plan = $filter('filter')(proj.plan_codes, {'item': lot.plan}, true);
                if(plan.length === 1) {
                    var trade_total = $filter('filter')(plan[0].trade_totals, {
                        'trade': vm.user.trade[0], 'revision': revision }, true);

                    if(trade_total.length === 1) {
                        total += trade_total[0].total;
                    } else {
                        if(vm.project_errors.indexOf(proj.name) === -1)
                            vm.project_errors.push(proj.name);
                    }
                } else {
                    toaster.pop('error', 'Problem Finding Plan', 'Could not find plan code ' + 
                        lot.plan + ' in project ' + proj.name);
                }

                //now get the option total for this lot
                _.each(lot.active_options, function(option) {
                    var trade_opt = $filter('filter')(option.totals, {
                        'trade': vm.user.trade[0]}, true)[0];
                    if(trade_opt) {
                        total += trade_opt.multiple * trade_opt.total;
                    }
                });

                // _.each(project_extras, function(extra) {
                //     if(extra.lot == lot.number) {
                //         total += extra.total;
                //     }
                // });
            }
        });

        _.each(project_extras, function(extra) {
                total += extra.total;
        });

        return total;
    };

    $scope.showSelected = function(sel) {
        $scope.selectedNode = sel;
    };
    
  }
]);



// WEBPACK FOOTER //
// ./packages/custom/accounts-receivable/public/controllers/tradesAccountsReceivable.js